import React from "react";
import {
  Box,
  Container,
  Flex,
  Text,
  Link,
  Icon,
  useColorModeValue,
  HStack,
} from "@chakra-ui/react";
import { FaLinkedin } from "react-icons/fa";
import { ReactComponent as LystoLogo } from "assets/img/lysto-logo-round.svg";
import { Link as RouterLink } from "react-router-dom";

const LandingFooter = () => {
  const bgColor = useColorModeValue("gray.100", "gray.800");
  const textColor = useColorModeValue("gray.600", "gray.400");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const linkHoverColor = useColorModeValue("blue.500", "blue.300");
  
  return (
    <Box bg={bgColor} py={6} borderTopWidth="1px" borderColor={borderColor}>
      <Container maxW="1400px" px={8}>
        <Flex 
          justify="space-between" 
          align="center"
          direction={{ base: "column", md: "row" }}
          gap={{ base: 6, md: 0 }}
        >
          {/* Logo and copyright */}
          <Flex align="center">
            <Box as={LystoLogo} width="36px" height="36px" mr={3} />
            <Text fontSize="sm" color={textColor} fontWeight="medium">
              © 2025 Awning Technologies Inc. &ldquo;Lysto AI&rdquo; All rights reserved.
            </Text>
          </Flex>
          
          {/* Links and social */}
          <HStack spacing={{ base: 4, md: 6 }} align="center">
            <Link 
              as={RouterLink}
              to="/privacy" 
              color={textColor}
              fontSize="sm"
              fontWeight="medium"
              _hover={{ textDecoration: "none", color: linkHoverColor }}
              transition="color 0.2s"
            >
              Privacy Policy
            </Link>
            <Box as="span" fontSize="sm" color={borderColor}>|</Box>
            <Link 
              as={RouterLink}
              to="/terms" 
              color={textColor}
              fontSize="sm"
              fontWeight="medium"
              _hover={{ textDecoration: "none", color: linkHoverColor }}
              transition="color 0.2s"
            >
              Terms of Service
            </Link>
            <Box as="span" fontSize="sm" color={borderColor}>|</Box>
            <Link 
              href="https://www.linkedin.com/company/lystoai" 
              isExternal
              color={textColor}
              _hover={{ color: linkHoverColor }}
              display="flex"
              alignItems="center"
              transition="color 0.2s"
              aria-label="LinkedIn"
            >
              <Icon as={FaLinkedin} boxSize={5} />
            </Link>
          </HStack>
        </Flex>
      </Container>
    </Box>
  );
};

export default LandingFooter; 